export default __webpack_public_path__ + "static/media/Portuguese-Mille-Feuille.2c1eab42.jpg";